var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.6217 3.5462 13.2004 6.5625 13.6754V9.30078H4.95703V7.5H6.5625V6.1225C6.5625 4.53789 7.5093 3.66211 8.9538 3.66211C9.64604 3.66211 10.3711 3.78516 10.3711 3.78516V5.33984H9.57267C8.78753 5.33984 8.4375 5.81104 8.4375 6.29492V7.5H10.2969L10.0084 9.30078H8.4375V13.6754C11.4538 13.2004 13.75 10.6217 13.75 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.befc3a520c9579e17c0fea3099c5bc92.svg";
export { ForwardRef as ReactComponent };